import {useCallback, useContext} from 'react'

import useSushi from './useSushi'
import {useWallet} from 'use-wallet'

import {Contract} from 'web3-eth-contract'
import BigNumber from "bignumber.js";
import {FarmContext} from "../contexts/farm_provider/farm_provider";
import {getBalanceNumber} from "../utils/formatBalance";

const useUnstake = () => {
    let {sC,tokenBalance} = useContext(FarmContext);

    const {account} = useWallet();
    const sushi = useSushi();
    const handleUnstake = useCallback(
        async (amount: any) => {
             // console.log( new BigNumber(amount).div(4).times(new BigNumber(10).pow(18)).toString(),);
            amount = new BigNumber(amount).div(4).times(new BigNumber(10).pow(18));
            let _balance:number = getBalanceNumber(tokenBalance);
            let _amount:number =  getBalanceNumber(amount);
            // console.log(amount.toString());

            // console.log(_balance - _amount < 1,_balance - _amount > -1);
            if(_balance - _amount < 1 && _balance - _amount > -1){
                amount = tokenBalance;
            }
            // console.log(amount.toString());
            const txHash = await sC.methods
                .withdraw(
                    amount.toString(),
                )
                .send({ from: account })
                .on('transactionHash', (tx:any) => {
                    return tx.transactionHash
                });
            console.log(txHash)
        },
        [account, sC, sushi,tokenBalance],
    );

    return {onUnstake: handleUnstake}
};

export default useUnstake
